import { useEffect, useState } from 'react';
import { InsightReportsResponse } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/InsightsDashboard';
import { fetchInsightReports as fetchInsightReportsFromApi } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/api/insightReports';

export type UseFetchInsightReportsReturnType = {
  isLoading: boolean;
  hasError: boolean;
  insightReports: InsightReportsResponse | null;
};

export const useFetchInsightReports = (
  corpId: string
): UseFetchInsightReportsReturnType => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const [insightReports, setInsightReports] =
    useState<InsightReportsResponse | null>(null);

  useEffect(() => {
    const fetchInsightReports = async (): Promise<void> => {
      if (!corpId) {
        setInsightReports(null);
        setHasError(true);
        setIsLoading(false);

        return;
      }

      try {
        setIsLoading(true);
        setHasError(false);

        const response = await fetchInsightReportsFromApi(corpId);
        setInsightReports(response);
      } catch (error) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInsightReports();
  }, [corpId]);

  return {
    isLoading,
    hasError,
    insightReports,
  };
};
